<p-card class="p-card container">
  <h3 class="text-center" i18n>✉️ Avis de modification</h3>

  <div class="layout__inner-card flex">
    <div
      [innerHTML]="
        modificationNoticeInfo.modificationNotice[modificationNoticeInfo.languageCode] | emMarkdown
      "></div>
  </div>

  <p-button
    [loading]="isLoading"
    [disabled]="modificationNoticeInfo.hasModificationDecision"
    (onClick)="send()"
    class="pt-5 flex justify-content-center"
    i18n-label
    label="Envoyer la lettre au client"
    icon="pi pi-check"></p-button>
</p-card>
